module.exports = __webpack_public_path__ + "static/media/disableFullScreen-light.edbe5933.svg";